import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { BillsPaginatorInterface } from '../models/bills.paginator.interface';
import { BillGsmDetailsPaginatorInterface } from '../models/bill-gsm-details.paginator.interface';
import { LedgerInterface } from '../models/ledger.interface';
import { PenaltyPaymentInterface } from '../models/penalty-payment.interface';
import {InvoiceLifecycleInterface} from "../models/invoice-lifecycle.interface";

@Injectable()
export class BillService {

  constructor(private apiService: ApiService) {}

  /**
   * Get bills list
   */
  get(): Observable<BillsPaginatorInterface> {
    return this.apiService.get('bills/1/12');
  }

  /**
   * Get penalties payment
   */
  getPenaltiesPayment(): Observable<Array<PenaltyPaymentInterface>> {
    return this.apiService.get('penalties/payment');
  }

  /**
   * Get customer ledger
   */
  getCustomerLedger(): Observable<LedgerInterface> {
    return this.apiService.get('customer/ledger');
  }

  /**
   * Get bill gsm details
   */
  getBillGsmDetails(phoneNumber: string, period: number, page: number, items: number, filter?: string): Observable<BillGsmDetailsPaginatorInterface> {
    return this.apiService.post('bill/gsm/details/' + page + '/' + items, {phoneNumber, period, filter});
  }

  download(billingId: number): Observable<Blob> {
    return this.apiService.getFile('file/download', { billingId });
  }

  getFileUrl(billingId: number, returnUrl?: boolean): Observable<{url: string}> {
    return this.apiService.getFileUrl('file/download', { billingId, returnUrl });
  }

  downloadFile(fileId: number, fileTypeSlug: string): Observable<{url: string}> {
    return this.apiService.getFileUrl('file/download', { fileId, fileTypeSlug, returnUrl: true });
  }

  downloadFileByParams(data: object): Observable<Blob> {
    return this.apiService.getFile('file/download', data);
  }

  getInvoiceLifecycle(billId: number): Observable<Array<InvoiceLifecycleInterface>> {
    return this.apiService.get('invoice/lifecycle/' + billId);
  }
}
